import { DateTime } from "luxon";

export const fromISOtoDate = date => DateTime.fromISO(date).toFormat("dd/MM/yyyy");

export const fromISOtoDatetime = date => DateTime.fromISO(date).toFormat("dd/MM/yyyy HH:mm");